module.exports = __webpack_public_path__ + "img/Icon_LockOpen_ActiveBlue.ffb6d7f5.svg";